import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { EmblemSetType } from "@/lib/domain/EmblemSet";
import type { EmblemModel } from "@/features/emblems/api/models/EmblemModel";

export interface EmblemRollRequestModel {
	readonly set: EmblemSetType;
}

export const useRoll = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<EmblemModel>, EmblemRollRequestModel> = requestModel => {
		return http<EmblemModel, EmblemRollRequestModel>({
			method: "POST",
			url: "/emblem/roll",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: ["userEmblemRolls"] });
				queryClient.invalidateQueries({ queryKey: ["emblems"] });
				queryClient.invalidateQueries({ queryKey: ["emblemStats"] });
				queryClient.invalidateQueries({ queryKey: ["specialEmblemStatus"] });
			}, 2500);
		}
	});
};
